import {
  meta,
  events,
  comment,
  deleteComment,
  getView,
  createRecent,
  getWO
} from '../service/preview'
import {
  pageCount,
  canroam
}
from '../../../src/config'
export default {
    namespaced: true,
    state(){
        return {
            fname: "",
            mtime: "",
            ctime: "",
            user_nickname: "",
            events: [],
            currentPage: 1,
            maxPage: false,
            initing: true,
            success: true,
            image: false,
            fver: 0,
            metaErr: '',
            viewErr: '',
            previewUrl: '',
            loading: true,
            doing: false,
            groupid: 0,
            downloadUrl: '',
            listLoading: false,
            isWO: true,
            ext: '',
            share_permission: null
        }
    },
    mutations:{
        INIT(state,{noinit}){
            state.currentPage = 1
            state.maxPage = false
            state.initing = !noinit
            state.listLoading = false
        },
        CLEARERR(state){
            state.metaErr = ''
            state.viewErr = ''
            state.previewUrl = ''
        },
        SAVE_FILE(state,fileinfo){
            state.fname = fileinfo.fname
            state.mtime = fileinfo.mtime
            state.ctime = fileinfo.ctime
            state.groupid = fileinfo.groupid
            state.user_nickname = fileinfo.user_nickname || fileinfo.modifier.name
            state.fver = fileinfo.fver
            state.id = fileinfo.id
            state.ext = fileinfo.ext
            state.parentid = fileinfo.parent
            state.share_permission = fileinfo.share_permission
        },
        SAVE_EVENTS(state, {list,noinit}) {
            state.currentPage === 1 ? state.initing = false : null
            state.currentPage += 1
            state.maxPage = list.length < pageCount
            state.events = noinit ? list : state.events.concat(list)
        },
        DELETE(state,commentid){
            state.events = state.events.filter(item => item.commentid != commentid)
        },
        METAERROR(state,err){
            state.metaErr = err
        },
        DOVIEW(state,{path,image}){
            state.loading = false
            state.image = image ? true : false
            state.previewUrl = path
        },
        VIEWERR(state,err){
            state.loading = false
            state.viewErr = err
        },
        DOING(state,flag){
            state.doing = flag
        },
        LOADING(state, flag) {
            state.listLoading = flag
        },
        CHANGE_WO(state,flag){
            state.isWO = flag
        }
    },
    actions:{
        flush({dispatch,commit},paload){
            commit('INIT',paload)
            dispatch('getMeta',paload)
        },
        getMeta({commit,dispatch},{fileid,historyid,noinit}){
            meta({fileid,historyid},({status,data}) => {
                if (status == 200) {
                    let result = data.fileinfo || data
                    let whiteList = ["doc", "dot", "wps", "wpt", "docx", "dotx", "docm", "dotm", "bas", "prg", "rtf", "htm", 
                    "html", "xls", "xlt", "et", "ett", "xlsx", "xltx", "csv", "xlsb", "xlsm", "xltm"
                    , "pptx", "ppt", "pot", "potx", "pps", "ppsx", "dps", "dpt", "pptm", "potm", "ppsm"
                    , "txt", "log", "c", "cpp", "h", "asm", "s", "java", "asp", "bat", "cmd", "xml", "lrc", "pdf"]
                    let fname = result.fname
                    let ext = fname.slice(fname.lastIndexOf('.')+1).toLowerCase()
                    result.ext = ext
                    !historyid && whiteList.includes(ext) ? dispatch('createRecent', result) : ''
                    commit('SAVE_FILE',result)

                    let {groupid,fileid} = result
                    dispatch('WOMeta',{groupid,historyid,fileid,noinit,ext})
                }else{
                    commit('METAERROR',data.result)
                    _dw.onEvent('drive_fileaction_preview',{
                        type: 'failed',
                        result: data.result
                    })
                }
            })
        },
        createRecent({commit,state},{
            groupid,
            parent,
            fileid,
            fsize,
            fname,
            ext
        }){
            let {browser,OS} = window.$ua
            let app_type = ''
            let idx = canroam.indexOf(ext)
            if (ext.toLowerCase() == 'pdf') {
                app_type = 'pdf'
            }else if (ext.toLowerCase() == 'txt' || (idx >= 0 && idx < 8)){
                app_type = 'wps'
            }else if(idx >= 8 && idx < 16){
                app_type = 'et'
            }else if(idx >= 16){
                app_type = 'wpp'
            }else{
                app_type = 'wps'
            }
            createRecent({
                app_type,
                current_device_type: 'web',
                current_device_name: OS + ' ' + browser,
                current_device_id: navigator.userAgent,
                fileid,
                size: fsize,
                name: fname,
                operation: 'open',
                status: 'ok',
                groupid,
                parent,
                file_ctime: state.ctime
            },({status,data}) => {

            })
        },
        getEvents({commit,state},{fileid,noinit}){
            if (state.maxPage || state.listLoading) {
              return
            }
            commit('LOADING', true)
            let offset = (state.currentPage - 1) * pageCount
            events({
                groupid: state.groupid,
                offset,
                count: pageCount,
                fileid
            },({status,data}) => {
                if (status === 200) {
                    commit('SAVE_EVENTS', {
                      list: data.events,
                      noinit
                    })
                }else{
                    commit('SAVE_EVENTS', {list:[]})
                }
                commit('LOADING', false)
            })
        },
        saveComment({commit,state,rootState,dispatch},{content,fileid}){
            comment({
                groupid: state.groupid,
                fver: state.fver,
                comment: content,
                fileid
            },({status,data}) => {
                if (status === 200) {
                    commit('TOAST', {
                      type: 'success',
                      msg: 'Commented'
                    }, {
                      root: true
                    })

                    commit('INIT',{fileid,noinit:true})
                    dispatch('getEvents',{fileid,noinit:true})

                }else{
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
            })
        },
        deleteComment({commit,state,rootState,dispatch},paload){
            let {commentid,fileid} = rootState.dialogData
            commit('DOING', true)
            deleteComment({
                commentid,
                fileid,
                groupid: state.groupid
            },({status,data}) => {
                if (status === 200) {
                    commit('TOAST', {
                      type: 'success',
                      msg: 'Deletecomsuc'
                    }, {
                      root: true
                    })
                    dispatch('close', {}, {
                      root: true
                    })
                    commit('DELETE',commentid)
                }else{
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                commit('DOING', false)
            })
        },
        view({
          commit,
          state,
          rootState,
          dispatch
        }, {fileid,historyid,groupid,dataInfo}) {
            let paload = {
                fileid,
                groupid,
                historyid,
                timestamp: (new Date()).getTime(),
                canvas: true,
                newstart: 1,
                recycle: false,
                complex: false
            }
          let cb = (res) => {
            if (res && res.data) {
                if (res.data.dotview) {
                    commit('DOVIEW', res.data.dotview)
                    window.midTime = (new Date()).getTime()
                }else{
                    commit('VIEWERR',res.data.result)
                    _dw.onEvent('drive_fileaction_preview', {
                        type: 'failed',
                        engine: 'wowserver',
                        filetype: state.ext,
                        result: res.data.result
                    })
                }
              
            } else if (res && res.sleep && !rootState.destory) {
              setTimeout(() => {
                getView(paload, cb)
              }, 1000 * res.sleep);
            } else {
              let msg = res ? res.result : 'errInter'
              commit('VIEWERR', msg)
              _dw.onEvent('drive_fileaction_preview', {
                type: 'failed',
                engine: 'wowserver',
                result: msg,
                filetype: state.ext
              })
            }
          }
          getView(paload, cb)
        },
        WOMeta({commit,dispatch,state},{fileid,groupid,historyid,noinit,ext}){
            // commit('CHANGE_WO', false)
            // dispatch('view', {
            //   groupid,
            //   fileid,
            //   historyid
            // })
            // dispatch('getEvents', {
            //   fileid,
            //   noinit
            // })
            let idx = canroam.indexOf(ext)
            getWO({fileid,groupid,version: state.fver,historyid},({status,data}) => {
                if (status == 200) {
                    if (data.view_link) {
                        commit('DOVIEW',{
                            path: data.view_link
                        })
                        window.midTime = (new Date()).getTime()
                    }else{
                        commit('CHANGE_WO',false)
                        dispatch('view', {
                          groupid,
                          fileid,
                          historyid
                        })
                        dispatch('getEvents', {
                          fileid,
                          noinit
                        })
                    }
                }else{
                    let msg = data ? data.result : 'errInter'
                    commit('METAERROR', msg)
                    dispatch('getEvents', {
                      fileid,
                      noinit
                    })
                    _dw.onEvent('drive_fileaction_preview', {
                       type: 'failed',
                       result: data.result,
                       filetype: state.ext
                    })

                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/preview.js